import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';

/**
 * QuizCardContent - 퀴즈 카드의 콘텐츠 섹션
 * EditableQuizCard/QuizCardUI.tsx (QuizCardContent)에서 복사
 * @component
 */
const QuizCardContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <div className={cn('flex flex-col pb-lg pt-0 gap-md w-full px-lg', className)} ref={ref} {...rest}>
      {children}
    </div>;
});
QuizCardContent.displayName = 'QuizCardContent';
export { QuizCardContent };